import React, { useContext, useRef, useState } from 'react';
import styles from "./Account.module.scss";
import { Info } from "../../components/Info";
import { UserInitials } from "../../components/common/UserInitials";
import  {Table }  from "../../components/Table";
import { useQuery, useMutation } from "@apollo/client";
import {
  CREATE_USER,
  ME,
  ME_PLUS_ORG,
  REQUEST_PASSWORD_CHANGE,
  UPDATE_USER_DETAILS,
  USERS_OF_ORGANISATION
} from '../../apollo/queries';
import { History } from "../../components/History";
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import { generateUniqueNumber } from '../../utils/numbers';
import { TableRowTrigger } from '../../apollo/types/TableRowTrigger';
import { Me } from '../../apollo/types/globalTypes';
import { useLazyQuery } from '@apollo/react-hooks';
import { UserContext } from '../../context/UserContext';
import { UsersTable } from '../../components/UsersTable';
import { AddUserForm } from '../../components/AddUserForm';
import { UserFormData } from '../../apollo/types/UserFormData';
import { FormikProps } from 'formik';
import { client } from '../../apollo/client';
import { useNavigate } from 'react-router-dom';

const personalData1 = (
  name: string = "-",
  organisation: string = "-",
  city: string = "-"
) => {
  return {
    theadData: ["NAME", "ORGANISATION", "CITY"],
    tbodyData: [
      {
        id: generateUniqueNumber().toString(),
        items: [name, organisation, city],
      },
    ],
  };
};

const personalData2 = (
  sector: string = "-",
  phoneNumber: string = "-",
  email: string = "-"
) => {
  return {
    theadData: ["SECTOR", "TELEPHONE", "EMAIL ADDRESS"],
    tbodyData: [
      {
        id: generateUniqueNumber().toString(),
        items: [sector, phoneNumber, email],
      },
    ],
  };
};


export const Account = () => {
  const navigate = useNavigate();
  const initialUserFormValues = {
    name: "",
    emailAddress: "",
    userFunction: "",
    language: "nl",
  }

  const [reloadPage, setReloadPage] = useState(false);
  const [mustLogin, setMustLogin] = useState(false);
  const [updateDetails, { data: userData }] = useMutation(UPDATE_USER_DETAILS);
  const userContext = useContext(UserContext);
  const formikRefUserForm = useRef<FormikProps<UserFormData>>(null);
  const [userFormData, setUserFormData] = useState<UserFormData>(initialUserFormValues)
  const [updatingUserSuccessful, setUpdatingUserSuccessful] = useState(false);
  const [updatingUserError, setUpdatingUserError] = useState(false);
  const [userPassword, setUserPassword] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);


  const [reloadUserData] = useLazyQuery<{ me: Me }>(ME, {
    onCompleted: (data) => {
      localStorage.setItem('me', JSON.stringify(data.me))
      if(reloadPage || mustLogin) {
        setTimeout(() => {
          if(mustLogin) {
            localStorage.clear()
          }
          window.location.reload()
        }, 500)
      }
    },
  });

  const [isChange, setIsChange] = useState(false);
  const [tableOneKey] = useState(generateUniqueNumber())
  const [tableTwoKey] = useState(generateUniqueNumber())
  const [itemThatTriggered, setItemThatTriggered] = useState<TableRowTrigger>({
    tableID: 0,
    rowIndex: -1
  });

  const [firstPersonalData, setFirstPersonalData] = useState(["", "", ""]);
  const [secondPersonalData, setSecondPersonalData] = useState(["", "", ""]);


  let { data } = useQuery(ME_PLUS_ORG, {
    onCompleted: (data) => {

      setFirstPersonalData([
        data?.me?.name,
        data?.me?.organisation?.name,
        data?.me?.organisation?.city,
      ]);

      setSecondPersonalData([
        data?.me?.organisation?.sector,
        data?.me?.phoneNumber,
        data?.me?.emailAddress,
      ]);
    },
    fetchPolicy: "no-cache"
  });

  const handleUpdateUserData = () => {
    setFirstPersonalData(cache1)
    setSecondPersonalData(cache2)
    updateDetails({
      variables: {
        userDetails: {
          name: cache1[0],
          phoneNumber: cache2[1],
          emailAddress: cache2[2],
          organisationName: cache1[1],
          organisationCity: cache1[2],
          organisationSector: cache2[0],
        },
      },
    }).then((result) => {
      // @ts-ignore
      const { name, phoneNumber, emailAddress, organisation } = result.data.updateUserDetails
      if(name !== data.me.name) {
        setReloadPage(true)
      }
      if(emailAddress !== data.me.emailAddress) {
        setMustLogin(true)
      }
      data.me.emailAddress = emailAddress
      data.me.name = name
      data.me.phoneNumber = phoneNumber
      data.me.organisation.name = organisation.name
      data.me.organisation.sector = organisation.sector
      data.me.organisation.city = organisation.city
      reloadUserData()
    });
    setIsChange(false)
  };

  let cache1 = firstPersonalData
  const handleChangeFirstPersonalData = (
      // @ts-ignore
      records
  ) => {
    cache1 = records
  };

  let cache2 = secondPersonalData
  const handleChangeSecondPersonalData = (
      // @ts-ignore
      records
  ) => {
    cache2 = records
  };

  const triggerChange = (tableKey: number) => {
    return (changeValue: boolean, index: number) => {
      if(!isChange) {
        setItemThatTriggered({tableID: tableKey, rowIndex: index})
        setIsChange(changeValue)
      } else {
        setItemThatTriggered({
          tableID: 0,
          rowIndex: -1
        })
      }
    }
  }

  const [requestPasswordChangeAction] = useMutation(REQUEST_PASSWORD_CHANGE, {
    onCompleted: (data) => {
      if(data?.requestChangePassword?.url) {
        navigate(data?.requestChangePassword?.url, {

        });
      }
    }
  })

  const [createUserAction] = useMutation(CREATE_USER, {
    onCompleted: (data) => {
      if(data !== null && data.addUserToOrganisation && data.addUserToOrganisation.code === 200) {
        setUpdatingUserSuccessful(true)
        setUpdatingUserError(false)
        setUserPassword(data.addUserToOrganisation.userPassword)
        setTimeout(() => {
          setUpdatingUserError(false)
          formikRefUserForm.current?.resetForm()
        }, 1500)
        client.refetchQueries({
          include: [USERS_OF_ORGANISATION]
        })
      } else {
        setUpdatingUserSuccessful(false)
        setUpdatingUserError(true)
        setErrorMessage(data.errors[0].message)
        setTimeout(() => {
          setUpdatingUserSuccessful(false);
          setUpdatingUserError(false)
        }, 2500)
      }
    },
    onError: (errors) => {
      setUpdatingUserError(true)
      setUpdatingUserSuccessful(false)
      // @ts-ignore
      setErrorMessage(errors.message)
      setTimeout(() => {
        setUpdatingUserSuccessful(false);
        setUpdatingUserError(false)
      }, 2500)
    },
  });


  const submitUserCreateForm = (values: UserFormData) => {
    createUserAction({
      variables: {
        input: {
          // @ts-ignore
          ...{ organisationId: parseInt(userContext?.organisation?.id) },
          ...values
        }
      }
    })
  }

  return (
    <div className={styles.wrapper}>
      {/*<GreetingsHeader title={userContext?.organisation?.id === 1 ? 'Gritd Admin' : ''} subtitle=""/>*/}
      <GreetingsHeader title='Manage Accounts' subtitle=""/>
      {/*<section className={styles.infoContainer}>*/}
      {/*  {data?.me ?*/}
      {/*      <Info*/}
      {/*          title="profiel"*/}
      {/*          description="Bekijk en wijzig hier jouw gegevens"*/}
      {/*          element={<UserInitials userName={data?.me?.name}/>}*/}
      {/*      /> : ''*/}
      {/*  }*/}
      {/*</section>*/}
      <section className={styles.personalData}>
        <h3 className={styles.header}>PERSONAL SETTINGS</h3>
        <h3 className={styles.inChange}>{isChange ? 'Changing settings' : ''}</h3>
        <div className={styles.tableContainer}>
          <Table
              uniqueKey={tableOneKey}
              table={personalData1(
                  data?.me?.name,
                  data?.me?.organisation?.name,
                  data?.me?.organisation?.city
              )}
              lastItemThatTriggered={itemThatTriggered}
              triggerChange={triggerChange(tableOneKey)}
              personalData={firstPersonalData}
              handleChangePersonalData={handleChangeFirstPersonalData}
              readOnly
              isChange={isChange}
          />
        </div>
        <div className={styles.tableContainer2}>
          <Table
              uniqueKey={tableTwoKey}
              table={personalData2(
                  data?.me?.organisation?.sector,
                  data?.me?.phoneNumber,
                  data?.me?.emailAddress
              )}
              lastItemThatTriggered={itemThatTriggered}
              triggerChange={triggerChange(tableTwoKey)}
              personalData={secondPersonalData}
              handleChangePersonalData={handleChangeSecondPersonalData}
              readOnly
              isChange={isChange}
          />
        </div>
        <div style={{display:"flex"}}>
          {!isChange ? (
              <>
                <button
                    type="button"
                    className={styles.buttonLeft}
                    onClick={() => requestPasswordChangeAction()}
                >
                  Change password
                </button>
                <button
                    type="button"
                    className={styles.button}
                    onClick={() => setIsChange(!isChange)}
                >
                  Edit
                </button>
              </>
          ) : (
              <div className={styles.buttons}>
                <button
                    type="button"
                    className={styles.button}
                    onClick={handleUpdateUserData}
                  >
                    Save
                  </button>
                  <button
                      type="button"
                      className={styles.button}
                      onClick={() => {
                        setItemThatTriggered({
                          tableID: 0,
                          rowIndex: -1
                        })
                        setIsChange(!isChange)
                      }}
                  >
                    Cancel
                  </button>
                </div>
            )}
        </div>
      </section>
      {data?.me.organisation?.contact?.id === userContext?.id &&
          <>
            <div className={styles.formBlock}>
              <h3 className={styles.header}>Users</h3>
              { userContext?.organisation?.id !== undefined &&
                  <UsersTable organisationId={userContext?.organisation?.id} canDeactivate={false}></UsersTable>
              }
            </div>
            <div className={styles.formBlock}>
              <h3 className={styles.header}>Add new user</h3>
              <br></br>
              <AddUserForm
                  formikRef={formikRefUserForm}
                  formData={userFormData}
                  submitValues={(values: UserFormData) => {
                    submitUserCreateForm(values)
                  }}
              ></AddUserForm>
              <p>After creation of a new user, the user will receive an email with a password and information on how to access the platform.</p>
              <br></br>
              <button
                  className={styles.send}
                  type='button'
                  onClick={() => {
                    formikRefUserForm.current?.submitForm()
                  }}
                  disabled={updatingUserError}
              >{`Create New User`}</button>
              {updatingUserSuccessful && (
                  <span className={styles.sendSuccessful}>User created successful, password for user: {userPassword}</span>
              )}
              {updatingUserError && (
                  <span className={styles.sendFailed}>Oops, something went wrong with creating User: `{errorMessage}`</span>
              )}
            </div>
        </>
      }
      {/*<section className={styles.history}>*/}
      {/*  <History options={history} />*/}
      {/*</section>*/}
    </div>
  );
};
